import auth from '../middlewares/auth';
import guest from '../middlewares/guest';

import { membersAdminRoute } from '@/routes/routes/membersAdminRoute';
import { parentListRoute } from '@/routes/routes/parentListRoute';
import { studentListRoute } from '@/routes/routes/studentListRoute';
import { professorListRoute } from '@/routes/routes/professorListRoute';
import { unitManagementRoute } from '@/routes/routes/unitManagementRoute';
import { learningVideosRoute } from '@/routes/routes/learningVideosRoute';
import { lectureVideosRoute } from '@/routes/routes/lectureVideosRoute';
import { courseLearningRoute } from '@/routes/routes/courseLearningRoute';
import { thinkingSkillRoute } from '@/routes/routes/thinkingSkillRoute';
import { holidayLectureRoute } from '@/routes/routes/holidayLectureRoute';
import { testLectureRoute } from '@/routes/routes/testLectureRoute';
import { packageRoute } from '@/routes/routes/packageRoute';
import { examQuestionsRoute } from '@/routes/routes/examQuestionsRoute';
import { examManagementRoute } from '@/routes/routes/examManagementRoute';
import { settingsLectureCategoryRoute } from '@/routes/routes/settingsLectureCategoryRoute';
import { settingsSubjectRoute } from '@/routes/routes/settingsSubjectRoute';
import { settingsQuestionTypeRoute } from '@/routes/routes/settingsQuestionTypeRoute';
import { settingsFolderUnitRoute } from '@/routes/routes/settingsFolderUnitRoute';
import { settingsFolderGradeRoute } from '@/routes/routes/settingsFolderGradeRoute';
import { settingsFolderSemesterRoute } from '@/routes/routes/settingsFolderSemesterRoute';
import { settingsAreaRoute } from '@/routes/routes/settingsAreaRoute';
import { settingsThinkingAreaRoute } from '@/routes/routes/settingsThinkingAreaRoute';
import { settingsPortionRoute } from '@/routes/routes/settingsPortionRoute';
import { settingsGradeRoute } from '@/routes/routes/settingsGradeRoute';
import { settingsSemestersRoute } from '@/routes/routes/settingsSemestersRoute';
import { gradeGroupRoute } from '@/routes/routes/gradeGroupRoute';
import { settingsWeeksRoute } from '@/routes/routes/settingsWeeksRoute';
import { settingsChapterRoute } from '@/routes/routes/settingsChapterRoute';
import { settingsConnectionServicesRoute } from '@/routes/routes/settingsConnectionServicesRoute';
import { settingsDifficultyRoute } from '@/routes/routes/settingsDifficultyRoute';
import { settingsPointRoute } from '@/routes/routes/settingsPointRoute';
import { settingsExamTypeRoute } from '@/routes/routes/settingsExamTypeRoute';
import { settingsParkingsRoute } from '@/routes/routes/settingsParkingsRoute';
import { noticesRoute } from '@/routes/routes/noticesRoute';
import { magazineSlidersRoute } from '@/routes/routes/magazineSlidersRoute';
import { ordersRoute } from '@/routes/routes/ordersRoute';
import { otherRoute } from '@/routes/routes/otherRoute';
import { textBookSettingsRoute } from '@/routes/routes/textBookSettingsRoute';
import { promotionSettingsRoute } from '@/routes/routes/promotionSettingsRoute';
import { faqRoute } from '@/routes/routes/faqRoute';
import { downloadFileRoute } from '@/routes/routes/downloadFileRoute';
import { inquiryTypeRoute } from '@/routes/routes/inquiryTypeRoute';
import { consultationRoute } from '@/routes/routes/consultationRoute';
import { productsRoute } from '@/routes/routes/productsRoute';
import { seoManageRoute } from '@/routes/routes/seoManageRoute';
import { landingPagesRoute } from '@/routes/routes/landingPagesRoute';

let routes = [
  {
    path: '/login',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/Login'),
    name: 'login',
    meta: {
      middleware: [guest],
    },
  },
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Index'),
    name: 'dashboard',
    meta: { auth },
  },
];

routes.push(...membersAdminRoute);
routes.push(...parentListRoute);
routes.push(...studentListRoute);
routes.push(...professorListRoute);
routes.push(...unitManagementRoute);
routes.push(...learningVideosRoute);
routes.push(...lectureVideosRoute);
routes.push(...courseLearningRoute);
routes.push(...thinkingSkillRoute);
routes.push(...holidayLectureRoute);
routes.push(...testLectureRoute);
routes.push(...packageRoute);
routes.push(...examQuestionsRoute);
routes.push(...examManagementRoute);
routes.push(...settingsLectureCategoryRoute);
routes.push(...settingsSubjectRoute);
routes.push(...settingsFolderUnitRoute);
routes.push(...settingsFolderGradeRoute);
routes.push(...settingsFolderSemesterRoute);
routes.push(...settingsQuestionTypeRoute);
routes.push(...settingsAreaRoute);
routes.push(...settingsThinkingAreaRoute);
routes.push(...settingsPortionRoute);
routes.push(...settingsGradeRoute);
routes.push(...settingsSemestersRoute);
routes.push(...gradeGroupRoute);
routes.push(...settingsWeeksRoute);
routes.push(...settingsChapterRoute);
routes.push(...settingsConnectionServicesRoute);
routes.push(...settingsDifficultyRoute);
routes.push(...settingsPointRoute);
routes.push(...settingsExamTypeRoute);
routes.push(...settingsParkingsRoute);
routes.push(...noticesRoute);
routes.push(...magazineSlidersRoute);
routes.push(...ordersRoute);
routes.push(...otherRoute);
routes.push(...textBookSettingsRoute);
routes.push(...promotionSettingsRoute);
routes.push(...faqRoute);
routes.push(...downloadFileRoute);
routes.push(...inquiryTypeRoute);
routes.push(...consultationRoute);
routes.push(...productsRoute);
routes.push(...seoManageRoute);
routes.push(...landingPagesRoute);

export default routes;
